var _rect, _rect2, _path, _path2, _g, _path3, _path4, _g2, _g3, _ellipse, _circle, _circle2, _circle3, _circle4, _path5, _path6, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCharacterRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 69,
    viewBox: "0 0 63 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.5033,
    y: 43.1821,
    width: 6.64756,
    height: 21.2086,
    rx: 3.32378,
    transform: "rotate(145.994 61.5033 43.1821)",
    fill: "#FF9F80"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.64756,
    height: 21.2086,
    rx: 3.32378,
    transform: "matrix(0.828978 0.559281 0.559281 -0.828978 1 43.1821)",
    fill: "#FF9F80"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5808 52.8072C29.6132 52.8072 29.6392 52.8294 29.6715 52.8406V43.6851L20.5049 45.7233C20.5049 45.7233 20.6021 49.566 20.7187 52.8517C20.7511 52.8517 20.7834 52.8183 20.8223 52.8183H29.5808V52.8072Z",
    fill: "#FF9F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.694 53.8987C20.7335 54.3759 20.7665 54.7337 20.7994 54.8881C20.8719 55.4285 20.5886 55.5688 20.2856 55.4565C19.1066 54.8671 18.0528 54.9232 17.0977 55.4565C15.7409 56.3267 15.5103 58.9161 16.6564 59.9617C17.3085 60.6213 18.0067 60.9371 18.7246 61.0002H27.8142C29.0722 60.9511 29.6387 60.1441 29.6716 58.7687V53.8706C29.6716 53.8706 29.6123 53.8917 29.5794 53.8917H20.694V53.8987Z",
    fill: "#A6E7BC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_681_699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.921 52.3662C29.921 52.3662 29.8613 52.3428 29.8282 52.3428H20.8642C20.8244 52.3428 20.7979 52.3662 20.7581 52.3662C20.3338 52.4286 19.9957 52.8423 19.9957 53.3574C19.9957 53.9193 20.3802 54.3798 20.8642 54.3798H29.8282C29.8613 54.3798 29.8879 54.3642 29.921 54.3564C30.352 54.3018 30.6901 53.8803 30.6901 53.3574C30.6901 52.8345 30.352 52.4208 29.921 52.3584V52.3662Z",
    fill: "#A6E7BC"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3271 52.7977C33.2947 52.7977 33.2688 52.8249 33.2364 52.8385V41.6484L42.4031 44.1397C42.4031 44.1397 42.3059 48.8362 42.1893 52.8521C42.1569 52.8521 42.1245 52.8113 42.0856 52.8113H33.3271V52.7977Z",
    fill: "#FF9F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.214 53.8987C42.1745 54.3759 42.1415 54.7337 42.1086 54.8881C42.0362 55.4285 42.3194 55.5688 42.6224 55.4565C43.8014 54.8671 44.8552 54.9232 45.8103 55.4565C47.1672 56.3267 47.3977 58.9161 46.2516 59.9617C45.5995 60.6213 44.9014 60.9371 44.1834 61.0002H35.0938C33.8358 60.9511 33.2693 60.1441 33.2364 58.7687V53.8706C33.2364 53.8706 33.2957 53.8917 33.3286 53.8917H42.214V53.8987Z",
    fill: "#A6E7BC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_681_699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.987 52.3662C32.987 52.3662 33.0466 52.3428 33.0798 52.3428H42.0437C42.0835 52.3428 42.11 52.3662 42.1498 52.3662C42.5742 52.4286 42.9123 52.8423 42.9123 53.3574C42.9123 53.9193 42.5277 54.3798 42.0437 54.3798H33.0798C33.0466 54.3798 33.0201 54.3642 32.987 54.3564C32.556 54.3018 32.2179 53.8803 32.2179 53.3574C32.2179 52.8345 32.556 52.4208 32.987 52.3584V52.3662Z",
    fill: "#A6E7BC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_681_699)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8168 7.73467C26.2463 4.98063 29.3887 5.7729 30.6246 8.24465C30.915 8.82549 31.8444 9.63865 33.2384 8.24465C34.4 6.7926 39.3371 3.88843 45.4358 11.7297L45.3835 11.6452C49.1659 16.5619 51.207 23.7588 52.0293 34.4212C52.7342 43.5806 52.5866 44.7445 50.39 47.3274C47.2694 50.9968 43.9807 50.9273 40.7431 47.1205L38.1538 44.0758L36.2012 47.1205C33.8094 50.8486 29.4445 51.0662 26.4998 47.6037C24.3532 45.0796 24.2942 45.0796 22.3507 47.6037C19.7557 50.9754 15.6417 50.8539 12.6334 47.3167C10.4675 44.7699 10.2824 43.4765 10.8807 35.0833C11.7128 23.4091 16.2195 12.0926 21.7513 7.7852C21.773 7.76829 21.7949 7.75144 21.8168 7.73467Z",
    fill: "#FF9F80"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.9448,
    cy: 30.1897,
    rx: 12.9861,
    ry: 12.4768,
    fill: "url(#paint0_radial_681_699)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.0756,
    cy: 24.5582,
    r: 1.9884,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.331399,
    cy: 0.331399,
    r: 0.331399,
    transform: "matrix(-1 0 0 1 28.4012 23.8955)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.3664,
    cy: 24.5582,
    r: 1.9884,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.331399,
    cy: 0.331399,
    r: 0.331399,
    transform: "matrix(-1 0 0 1 35.692 23.8955)",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2132 21.1692C25.9858 21.251 25.8539 21.3469 25.8027 21.4205C25.7238 21.5339 25.568 21.5618 25.4547 21.483C25.3413 21.4041 25.3134 21.2483 25.3922 21.135C25.532 20.9341 25.782 20.793 26.0439 20.6987C26.3149 20.6012 26.638 20.5397 26.9695 20.5231C27.6173 20.4906 28.3769 20.628 28.8335 21.1048C28.929 21.2045 28.9256 21.3628 28.8259 21.4583C28.7262 21.5538 28.5679 21.5504 28.4724 21.4507C28.1652 21.1299 27.588 20.9927 26.9945 21.0224C26.7053 21.0369 26.4316 21.0906 26.2132 21.1692Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7782 21.1635C33.598 21.2413 33.4942 21.3316 33.4527 21.4031C33.3835 21.5226 33.2305 21.5633 33.111 21.494C32.9916 21.4248 32.9509 21.2718 33.0201 21.1523C33.1378 20.9494 33.3523 20.8027 33.5799 20.7044C33.8134 20.6036 34.091 20.5403 34.3752 20.5232C34.9324 20.4897 35.5879 20.6328 35.9781 21.1218C36.0643 21.2297 36.0466 21.387 35.9387 21.4731C35.8308 21.5593 35.6735 21.5416 35.5873 21.4337C35.341 21.125 34.8824 20.9936 34.4052 21.0223C34.1722 21.0363 33.9525 21.0882 33.7782 21.1635Z",
    fill: "black"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_681_699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6937 30.4156C28.4844 32.6617 33.1888 32.8253 35.1033 30.4156C35.3686 30.0177 35.4438 29.5446 35.4349 29.0406C35.3111 28.0944 34.3826 27.6478 33.5602 27.6655C33.0164 27.6566 32.7688 27.8335 32.4814 28.0325L32.4814 28.9477C32.4814 29.9779 29.5146 30.0885 29.5146 28.9477L29.5146 28.1032C29.0503 27.8733 28.5905 27.6478 28.0201 27.6655C27.2287 27.6566 26.4814 28.1121 26.3134 28.9123C26.2648 29.3501 26.2957 29.9779 26.6892 30.4112L26.6937 30.4156Z",
    fill: "#020304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4858 28.9476L32.4858 28.0323C32.1852 28.2401 31.8403 28.4745 31.0665 28.5408C30.4696 28.5673 29.9921 28.333 29.5234 28.1031L29.5234 28.9476C29.5234 30.0883 32.4902 29.9778 32.4902 28.9476L32.4858 28.9476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5577 31.719C29.0213 31.2829 31.7012 30.5975 33.2907 31.7189C31.8218 32.3718 29.9882 32.317 28.5577 31.719Z",
    fill: "#FF3838"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_681_699",
    x: 13.9957,
    y: 46.3428,
    width: 30.6945,
    height: 22.0371,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_681_699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_681_699",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_681_699",
    x: 26.2178,
    y: 46.3428,
    width: 30.6945,
    height: 22.0371,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_681_699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_681_699",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_681_699",
    x: 0.585815,
    y: 0,
    width: 61.8199,
    height: 64.0649,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_681_699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_681_699",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_681_699",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.9448 30.1897) rotate(90) scale(12.4768 12.9861)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141692,
    stopColor: "#FFB1D2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_681_699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.13476,
    height: 4.49664,
    fill: "white",
    transform: "translate(35.4349 32.1621) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterRed);
export default __webpack_public_path__ + "static/media/character_red.80ba82bbdefe8a63a5c948cda96344c7.svg";
export { ForwardRef as ReactComponent };